import { ColoursObj, Typography } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { getFileName } from "../../feat/media/media.slice";
import { Utils } from "../../utils";

interface IFileListProps {
  id?: string;
  data: any;
  renderOptions: IFileListOptions;
  past?: boolean;
}

interface IFileListOptions {
  value: string;
}
export const FileList = ({ id, data, renderOptions, past }: IFileListProps) => {
  const [fileUrls, setFileUrls] = useState<string[]>([]);

  useEffect(() => {
    const files = (data[renderOptions.value] ?? []) as string[];
    if (typeof files === "string") {
      setFileUrls(JSON.parse(files));
    } else {
      setFileUrls(files);
    }
  }, [data, renderOptions.value]);

  return (
    <>
      {fileUrls.length > 0 && (
        <Stack spacing="12px" sx={{
          paddingBottom: "24px"
        }}>
          {fileUrls &&
            typeof fileUrls !== "undefined" &&
            fileUrls.map((f, i) => {
              return (
                <Stack key={i} spacing="12px" direction="row" sx={{
                  flexWrap: "wrap"
                }}>
                  <Typography
                    id={`${id}Uploadedfile`}
                    onClick={() => Utils.downloadAndOpenFile(f)}
                    color={past ? ColoursObj.shades.shade2 : undefined}
                    variant="bodyRegularUnderlined"
                  >
                    {getFileName(f)}
                  </Typography>
                </Stack>
              );
            })}
        </Stack>
      )}
    </>
  );
};
